import React from 'react';
import { Edit, useForm, useSelect } from '@refinedev/antd';
import { Form, Input, Select, InputNumber } from 'antd';
import { ScreenType } from '@wellverse/shared-ts';

export const SurveyScreenEdit: React.FC = () => {
  const { formProps, saveButtonProps } = useForm({ resource: 'survey-screens' });
  const { selectProps } = useSelect({
    resource: 'surveys',
    optionLabel: 'name',
    optionValue: 'id',
  });

  return (
    <Edit resource="survey-screens" saveButtonProps={saveButtonProps}>
      <Form {...formProps} layout="vertical">
        <Form.Item label="Survey" name="surveyId" rules={[{ required: true }]}>
          <Select {...selectProps} placeholder="Select a survey" />
        </Form.Item>
        <Form.Item label="Screen Key" name="screenKey" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="Type" name="type" rules={[{ required: true }]}>
          <Select>
            {Object.values(ScreenType).map((t) => (
              <Select.Option key={t} value={t}>
                {t}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Order Index" name="orderIndex" rules={[{ required: true }]}>
          <InputNumber style={{ width: '100%' }} min={0} />
        </Form.Item>
        <Form.Item
          label="Metadata (JSON)"
          name="metadata"
          getValueProps={(value) => ({ value: value ? JSON.stringify(value, null, 2) : '' })}
          normalize={(value) => {
            if (!value || typeof value !== 'string') return value;
            const trimmed = value.trim();
            if (!trimmed) return null;
            try { return JSON.parse(trimmed); } catch { return '__INVALID_JSON__'; }
          }}
          rules={[
            {
              validator: (_, value) => {
                if (value === '__INVALID_JSON__') {
                  return Promise.reject(new Error('Invalid JSON format'));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input.TextArea rows={4} placeholder='{"title":"Welcome","subtitle":"..."}' />
        </Form.Item>
      </Form>
    </Edit>
  );
};
